module.exports = __webpack_public_path__ + "img/1527249338.7f0bd53a.jpg";